import { useEffect } from 'react';
import {
	FilterList,
	FilterListItem,
	FilterLiveSearch,
	useGetOne,
	useListFilterContext,
	useTranslate
} from 'react-admin';
import {
	ImagesearchRoller,
	MonetizationOn,
	SquareFoot
} from '@mui/icons-material';
import { Box } from '@mui/material';
import { ActionsFilter } from './ActionsFilter';
import { areaFilters } from './constants';
import { PriceFilterSlider } from './PriceFilterSlider';

export const ApartmentsFilter = () => {
	const translate = useTranslate();
	const { setFilters } = useListFilterContext();

	const { data: pricesSummary, isPending } = useGetOne(
		'apartments_price_summary',
		{
			id: 'summary'
		}
	);

	const {
		rent_usd_object_price_max,
		rent_usd_object_price_min,
		sale_usd_object_price_max,
		sale_usd_object_price_min
	} = pricesSummary || {};

	useEffect(() => {
		return () => {
			setFilters({}, {});
		};
	}, []);

	return (
		<Box width="13em" minWidth="13em" mt={5}>
			<FilterLiveSearch
				hiddenLabel
				sx={{
					display: 'block',
					marginTop: 3,
					'& .MuiFilledInput-root': { width: '100%' }
				}}
				placeholder={translate('objects.filters.search')}
			/>
			<FilterList label="objects.filters.area" icon={<SquareFoot />}>
				{areaFilters.map(({ label, filterValue }) => (
					<FilterListItem
						key={label}
						label={`${label} м²`}
						value={filterValue}
					/>
				))}
			</FilterList>
			<ActionsFilter />
			<FilterList label="objects.filters.state" icon={<ImagesearchRoller />}>
				<FilterListItem
					label="З ремонтом"
					value={{
						'state@in': '(3,4)'
					}}
				/>
				<FilterListItem
					label="Без ремонту"
					value={{
						'state@in': '(1,2)'
					}}
				/>
			</FilterList>
			<FilterList label="objects.filters.price" icon={<MonetizationOn />}>
				<PriceFilterSlider type="rent" max={rent_usd_object_price_max || 0} />
				<PriceFilterSlider type="sale" max={sale_usd_object_price_max || 0} />
			</FilterList>
		</Box>
	);
};
